import React from 'react';
import { Box } from '@mui/material';
import HealthPassCard from '../HealthPassCard';

interface Props {
  screening: Record<string, unknown>;
}

const PassDisplayStep: React.FC<Props> = ({ screening }) => {
  const passRecord = screening.pass_record as Record<string, unknown> | undefined;

  if (!passRecord) {
    return <Box sx={{ p: 2, color: 'text.secondary' }}>No pass generated yet.</Box>;
  }

  return (
    <Box>
      <HealthPassCard passRecord={passRecord as unknown as Parameters<typeof HealthPassCard>[0]['passRecord']} />
    </Box>
  );
};

export default PassDisplayStep;
